import { CHAIN_NAMESPACES, LoginMethodConfig } from "@toruslabs/base-controllers";
import { MAINNET_CHAIN_ID } from "@toruslabs/ethereum-controllers";
import { CHAIN_IDS } from "@toruslabs/solana-controllers";
import { type AuthConnectionConfig, storageAvailable, WEB3AUTH_NETWORK, type WEB3AUTH_NETWORK_TYPE } from "@web3auth/auth";

const { VITE_WEB3AUTH_NETWORK, VITE_WEB3AUTH_CLIENT_ID, VITE_BACKEND_API_URL, VITE_BUILD_ENV } = import.meta.env as Record<string, string>;

const baseUrl = window.location.origin;
const baseRoute = baseUrl + import.meta.env.BASE_URL;
const redirectURI = `${baseUrl}/redirect`;

const appVersion = import.meta.env.VITE_TORUS_BUILD_VERSION;

const { hash, search } = window.location;
// search also has a ? in the value.
const finalUrlParams = new URLSearchParams(decodeURIComponent(`?${hash.slice(1)}&${search.slice(1)}`));

const sessionNamespace = finalUrlParams.get("sessionNamespace");
const embedNonce = finalUrlParams.get("nonce") || "";

export const checkSimpleHashDisabled = () => import.meta.env.VITE_DISABLE_SIMPLE_HASH === "true";

const config = {
  baseRoute,
  appVersion,
  commonApiHost: "https://common-api.tor.us", // not used
  api: VITE_BACKEND_API_URL,
  dashboardApi: "https://api-dashboard.web3auth.io",
  coinGeckoApi: "https://api.coingecko.com/api/v3",
  web3AuthClientId: VITE_WEB3AUTH_CLIENT_ID,
  web3AuthNetwork: (VITE_WEB3AUTH_NETWORK as WEB3AUTH_NETWORK_TYPE) || WEB3AUTH_NETWORK.SAPPHIRE_MAINNET,
  defaultChainNamespace: CHAIN_NAMESPACES.EIP155,
  defaultChainIds: {
    [CHAIN_NAMESPACES.EIP155]: MAINNET_CHAIN_ID,
    [CHAIN_NAMESPACES.SOLANA]: CHAIN_IDS.SOLANA_MAINNET,
  },
  buildEnv: VITE_BUILD_ENV || "production",
  storageAvailability: {
    local: storageAvailable("localStorage"),
    session: storageAvailable("sessionStorage"),
  } as Record<string, boolean>,
  sessionNamespace,
  embedNonce,
  redirect_uri: redirectURI,
  authConnectionConfig: [] as AuthConnectionConfig,
  loginMethodConfig: {} as LoginMethodConfig,
  loginChannelPrefix: "auth",
  sentrySampleRate: "0.2",
  sentryTransactionSampleRate: "0.001",
  mainnetAuthServiceSignatures: {
    "https://torus.web3auth.io": "MEUCIQCevFVjkPIcHzS7ZaI7tkmpr-aMN5ZmaSUBE0MLrkGY6wIgXYarvVw9ACVjBC48Fl9JfNmk3uLrKNKBXPL58yy2rdQ",
    "https://develop-wallet.web3auth.io": "MEQCIGMqUOMazwstHhjRU_Zxk7qIqnBiq0DV2985RpAnTMSVAiBhjd_b9GLU4S8w7LHoeCUYxs-qiQcUHFatkahI8JTI0A",
    "https://staging-wallet.web3auth.io": "MEUCIQDHl7-xeAXPJCKCBikZ5jirxpj_3p6FbhFe_IRo4X0nvQIgP7Lu1q_AqJVgNjuer5LPMjR77_G2Ue1VurHhk6IRm5A",
    "https://wallet.web3auth.io": "MEQCIF8HMabwjbUXuqBtdtYBOEaU9G_wC9GHlaDYIhG-pIDWAiAmABYH1XAM_cizoa3s5TUQL36xve5srBK9jIqhnMpGgA",
  } as Record<string, string>,
  legacySolanaWalletProjectId: "BImWlKqOHk90Eth1F7sq29AbQQWsPDBCbKPbTpbPR7KcUzdNO8DkqlTQoOyIlzK_QVGChKft-1QRjc8yrF7mEVE",
  getDefaultChainId: () => {
    return config.defaultChainIds[config.defaultChainNamespace];
  },
};

export default config;
